export const CAMERA_MOBILE = [
  {
    offset: 0,
    options: {
      duration: 2000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 0,
      positionY: -2.89,
      positionZ: 7.16,
      targetX: 0,
      targetY: -2.87,
      targetZ: 5.03
    }
  },
  {
    offset: 1000,
    options: {
      duration: 2000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 0,
      positionY: 0.31,
      positionZ: 7.55,
      targetX: 0,
      targetY: -47.71,
      targetZ: -39.52
    }
  },
  {
    offset: 3000,
    options: {
      duration: 4000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 0,
      positionY: 24.19,
      positionZ: 10.43,
      targetX: 0,
      targetY: -47.7,
      targetZ: 7.43
    }
  }
]

export const PHONE_MOBILE = [
  {
    offset: 0,
    options: {
      duration: 4000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutBack'
    },
    values: {
      positionX: 0,
      positionY: -2.835,
      positionZ: 5.132,
      rotationX: 1.6,
      rotationY: 0,
      rotationZ: 0
    }
  },
  {
    offset: 0,
    options: {
      duration: 6000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 0,
      positionY: -2.835,
      positionZ: 5.132,
      rotationX: 0.062,
      rotationY: 0.062,
      rotationZ: 0
    }
  }
]

export const CAMERA = [
  {
    offset: 0,
    options: {
      duration: 4000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: -1.46,
      positionY: -6.06,
      positionZ: 5.66,
      targetX: -6.75,
      targetY: -2,
      targetZ: -3.24
    }
  },
  {
    offset: 1000,
    options: {
      duration: 4000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 6.4,
      positionY: -2.39,
      positionZ: 14,
      targetX: -6.75,
      targetY: -2,
      targetZ: 0
    }
  }
]

export const PHONE = [
  {
    offset: 0,
    options: {
      duration: 2000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutBack'
    },
    values: {
      positionX: 0,
      positionY: -4.56,
      positionZ: 10.735,
      rotationX: 0.444,
      rotationY: 0.445,
      rotationZ: 0
    }
  },
  {
    offset: 0,
    options: {
      duration: 5000,
      delay: 0,
      elasticity: 7,
      endDelay: 0,
      easing: 'easeInOutCubic'
    },
    values: {
      positionX: 0,
      positionY: -4.578,
      positionZ: 7.193,
      rotationX: 0.198,
      rotationY: 0,
      rotationZ: 0
    }
  }
]
